<ridango-ui-dialog-layout [attr.title]="translatedTitle" title="AREA_INFO_MODAL_TITLE">
    <div class="p-1">
        <div
            class="pt-1"
            [ngClass]="{ 'pb-2': env.PURCHASE.EXTRA_ZONE_MAP_INFO, 'pb-4': !env.PURCHASE.EXTRA_ZONE_MAP_INFO }">
            {{ 'AREA_INFO_MODAL_DESCRIPTION' | translate }}
        </div>

        <div
            class="pb-4"
            *ngIf="env.PURCHASE.EXTRA_ZONE_MAP_INFO"
            innerHtml="{{ 'PURCHASE_EXTRA_ZONE_MAP_INFO' | translate }}"
            ridangoTranslatedLink></div>

        <div class="img-box">
            <img
                src="{{ assetsPath$ | async }}/{{ data?.mapFile ?? 'map_details.png' }}"
                alt="{{ 'ZONE_MAP_IMG_ALT' | translate }}" />
        </div>
    </div>
</ridango-ui-dialog-layout>
